import React from "react";
import Button from "@mui/material/Button";

const CommonButton = ({
  variant,
  color = "primary",
  startIcon = {},
  textColor = "",
  background = "",
  onClick,
  children,
  margin = "auto",
  disabled = false,
  width = "auto",
  minWidth = "100px",
  maxWidth = `auto`,
}) => {

  const hasStartIcon = React.isValidElement(startIcon);

  
  return (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      {...(hasStartIcon && { startIcon })}
      sx={{
        fontFamily: "Geist, sans-serif",
        textTransform: "none",
        padding: "8px 16px",
        fontSize: "14px",
        height: "35px",
        margin,
        background,
        border: `1px solid ${color}`,
        width,
        maxWidth,
        minWidth,
        color: textColor,
        '&.Mui-disabled': {
          background: "#f0f0f0", // custom disabled background
          color: "#a0a0a0",       // custom disabled text
          border: '1px solid #ccc', // optional
          cursor: 'not-allowed'
        }
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default CommonButton;
